/**
 * Created by summer on 2020/9/19.
 */
import Vue from 'vue'
import axios from 'axios'
import qs from 'qs'
import router from '../router'
import { Toast } from 'vant';
Vue.use(Toast);
/**
 * 封装axios的通用请求
 * @param  {string}   method     get\post\put\delete
 * @param  {string}   url       请求的接口URL
 * @param  {object}   param     传的参数，没有则传空对象
 */
let access_token = localStorage.getItem('access_token') ? localStorage.getItem('access_token') : ''
// 第二种: 使用axios.create创建一个新的axios实例，统一对数据进行处理, 同时也要借助qs模块
axios.interceptors.request.use(
    config => {
    if (access_token) { // 每次发送请求之前判断是否存在token，如果存在，则统一在http请求的header都加上token，不用每次请求都手动添加了
        config.headers.Authorization = access_token;
    }
    // console.log(config)
    return config;
},
error => {

    config => {
        if (access_token) { // 每次发送请求之前判断是否存在token，如果存在，则统一在http请求的header都加上token，不用每次请求都手动添加了
            config.headers.Authorization = access_token;
        }

        return config;
    },
    error => {

        // console.log("========================");
        return Promise.reject(err);
    }
});

// http response 服务器响应拦截器，这里拦截401错误，并重新跳入登页重新获取token
axios.interceptors.response.use(

    response => {
        console.log('response',response)
        if (response.data) {
            switch (response.data.code) {
                case 0 :
                    Toast(response.data.msg);
                    return false;
                    break;
                case 401:
                //     window.location.href = 'https://open.weixin.qq.com/connect/oauth2/authorize?appid='+Vue.ap
                //     &redirect_uri=http%3A%2F%2Fnba.bluewebgame.com%2Foauth_response.php&response_type=code
                // &scope=snsapi_userinfo&state=STATE#wechat_redirect'
                    break;
                    
                // case 10005:
                //     // 这里写清除token的代码
                //     localStorage.removeItem('user')
                //     localStorage.removeItem('userfrom')
                //     // console.log('token无效')
                //     router.replace({
                //         path: '/',
                //         query: {
                //             redirect: router.currentRoute.fullPath
                //         } //登录成功后跳入浏览的当前页面
                //     })
                //     break;
            }
        }
        return response;
    },
    error => {
        if (error.response) {
            switch (error.response.status) {
                case 401:
                    let appid = 'wxeb3768e3b8b71c18'
                    let baseUrl = 'http://swimming.view.lvseshixian.com//#';
                    let url = encodeURIComponent(baseUrl+router.currentRoute.fullPath);
                    window.location.href = 'https://open.weixin.qq.com/connect/oauth2/authorize?appid='+appid+'&redirect_uri='+url+'&response_type=code&scope=snsapi_userinfo&state=STATE#wechat_redirect'
                break;
                case 403:

                    break;
                    case 405:
                        router.replace({
                                    path: '/present/child-bind',
                                    query: {
                                        
                                    } //登录成功后跳入浏览的当前页面
                                })
                        break;
                        
                        case 406:
                        router.replace({
                                    path: '/coach/coach-bind',
                                    query: {
                                        
                                    } //登录成功后跳入浏览的当前页面
                                })
                        break;
                        case 408:
                        router.replace({
                                    path: '/adviser/adviser-bind',
                                    query: {
                                        
                                    } //登录成功后跳入浏览的当前页面
                                })
                        break;
                        case 410:
                        router.replace({
                                    path: '/present/child-bind',
                                    query: {
                                        is_invite:true
                                    } //登录成功后跳入浏览的当前页面
                                })
                        break;
                case 504:
                    break;
                // router.push({
                //     path: '/offLine'
                // })
            }
        }
        return Promise.reject(error)
});

function http (url, param, Methods) {
    let method
    if (Methods) {
        method = Methods
    } else {
        method = 'post'
    }
    param = param && typeof param === 'object' ? param : {}
    const config = {
        url: url,
        method: method,
        transformRequest: [function (param) {
            return qs.stringify(param)
        }],
        headers: {
            'X-Requested-With': 'XMLHttpRequest'
        }
    }

    // console.log("http__param==",param);
    // post请求时需要设定Content-Type
    if (method === 'post') {
        config.headers['Content-Type'] = 'application/x-www-form-urlencoded; charset=UTF-8';
        config.data = param
    } else if (method === 'get') {
        config.params = param
    }

    return axios(config)
}

export {
    http
}



//////////////////
// WEBPACK FOOTER
// ./common/http/axios.js
// module id = null
// module chunks = 